module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter16"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch16"
    }
  }, [_vm._v("Nona’s Umbrian Lentil Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I remember this soup from childhood, with its warm inviting aroma and stick-to-your-ribs quality. One bowl of this soup and I could return to playing with my friends filled with energy! I like to use brown lentils in this soup because they are easy to find and make a very nice soup. My grandmother’s roots in Umbria account for the large amount of celery in this dish. In Umbria, they grow a lot of celery, and the most prized is the "), _c('i', [_vm._v("sedano nero")]), _vm._v(", or black celery. It’s not black at all but has a milky white base from being covered while growing, and very dark, almost black, green leaves and stalks. The celery in this dish not only adds flavor but also texture to our soup. "), _c('i', [_vm._v("Buon appetito!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 tablespoons extra-virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large onion, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 medium carrots, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 stalks celery with leaves, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons dried whole sage leaves or 2 whole fresh sage leaves, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One 14- to 15-ounce can chopped plum tomatoes, drained")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups brown lentils")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 cups vegetable broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a large skillet over medium-high heat. Add the onion, garlic, carrots, celery, and sage leaves and sauté until the garlic and onion are fragrant, 3 to 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the tomatoes and cook for 2 to 3 minutes to evaporate some of the juices. Transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("stir in the lentils and broth. Cover the cooker and cook on high for 4 hours or on low for 7 to 8 hours, until the lentils are tender. Check the soup at around 3 or 6 hours to make sure there is enough broth and the soup isn’t sticking to the pan; add more broth if it is sticking.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("season with salt and pepper before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94edcbda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/022-chapter16.vue
// module id = 120
// module chunks = 0